import { ArrowRight, MoreHorizontal } from "lucide-react";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

interface ChatRoomItemProps {
  chatRoomId: string;
  chatRoomName: string;
  phase: number;
  onClick: () => void;
  onNextPhase: () => void;
}

export function ChatRoomItem({ chatRoomName, phase, onClick, onNextPhase }: ChatRoomItemProps) {
  return (
    <div className="flex items-center space-x-4 p-3 hover:bg-gray-100 rounded-lg transition-colors">
      <div className="flex-grow cursor-pointer" onClick={onClick}>
        <div className="flex items-center space-x-4">
          <Avatar className="w-12 h-12">
            <AvatarFallback>{phase}</AvatarFallback>
          </Avatar>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-gray-900 truncate flex items-center">
              {chatRoomName}
              <Badge variant="secondary" className="ml-2">
                フェーズ {phase}
              </Badge>
            </h3>
          </div>
        </div>
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="flex-shrink-0">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onNextPhase();
            }}
          >
            <ArrowRight className="mr-2 h-4 w-4" />
            <span>次のフェーズへ</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
